import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { DURATION, EASE_OUT_EXPO } from '../../lib/motion';

type Theme = 'light' | 'dark';

const STORAGE_KEY = 'travessa:theme';

function resolveInitialTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/** Applied to <html> so CSS custom properties switch without a React re-render. */
export function applyStoredTheme(): void {
  const theme = resolveInitialTheme();
  document.documentElement.dataset.theme = theme;
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(
    () => (document.documentElement.dataset.theme as Theme) ?? 'light',
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <button
      type="button"
      onClick={() => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))}
      aria-label={theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}
      className="grid size-10 place-items-center rounded-full border border-[var(--border-subtle)] transition-colors hover:bg-[var(--surface-sunken)]"
    >
      <motion.span
        key={theme}
        initial={{ rotate: -90, opacity: 0, scale: 0.6 }}
        animate={{ rotate: 0, opacity: 1, scale: 1 }}
        transition={{ duration: DURATION.fast, ease: EASE_OUT_EXPO }}
        className="text-base leading-none"
      >
        {theme === 'dark' ? '☀️' : '🌙'}
      </motion.span>
    </button>
  );
}
